import React, { useState } from 'react'
import './NewExpense.css';
import ExpenseForm from './ExpenseForm';

const NewExpense = (props) => {
  const saveExpenseDataHandler = (enteredExpenseData) =>{
    const expenseData = {
      ...enteredExpenseData,
      id: Math.random().toString()
    };
    // console.log(expenseData);
    props.onAddExpense(expenseData);
    setinserted(false);
  }
  const [inserted, setinserted] = useState(false);
  const viewFormHandler = () => {
    setinserted(true)
  }
  const exitFormHandler = () => {
    setinserted(false)
  }
  return (
    <div className='new-expense'>
      {!inserted && <button onClick={viewFormHandler}>Add New Expense</button> }
      {inserted && <ExpenseForm onSaveExpenseData={saveExpenseDataHandler} exitForm={exitFormHandler}/> }
    </div>
  )
}

export default NewExpense